var map = {
	"./adult/de/readingtest-text.js": 857,
	"./adult/nn/readingtest-text.js": 858,
	"./adult/no/readingtest-text.js": 859,
	"./youth/de/readingtest-text.js": 860,
	"./youth/nn/readingtest-text.js": 861,
	"./youth/no/readingtest-text.js": 862,
	"./youth/se/readingtest-text.js": 863
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 856;